import axios from 'axios';

const api = axios.create({ baseURL : 'https://v1-csapi.compsoft.com.br:826/' });
//const api = axios.create({ baseURL : 'http://192.168.0.14:9008/' });

//api.defaults.headers.common = { Authorization : `bearer ${localStorage.getItem('delphireact-token')}` };

export default api;